import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { RoundExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/RoundExpression";

export class RoundExpressionEditor extends ExpressionRuleEditor<RoundExpression> {
    render() {
        return (
            <ExpressionPiece>
                round
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
